import { VoiceOrderProvider } from "@/contexts/VoiceOrderContext";

export function ConditionalVoiceProvider({
  children,
  isSiteManager,
}: {
  children: React.ReactNode;
  isSiteManager: boolean;
}) {
  if (isSiteManager) {
    return <VoiceOrderProvider>{children}</VoiceOrderProvider>;
  }
  return <>{children}</>;
}
